import { initState } from './store';
import { LOCAL_AUTH_JWT, LOCAL_EMAIL_ID, LOCAL_EXPIRES_AT, LOCAL_NAME } from '../utils/constants';

const configureAuthStore = () => {
    const actions = {
        LOGIN: (currentState, payload) => {
            localStorage.setItem(LOCAL_AUTH_JWT, payload.data.token);
            localStorage.setItem(LOCAL_EXPIRES_AT, payload.data.expiresAt);
            localStorage.setItem(LOCAL_EMAIL_ID, payload.data.email);
            localStorage.setItem(LOCAL_NAME, payload.data.name);

            let newAuthData = {
                ...currentState.authData,
                email: payload.data.email,
                name: payload.data.name,
                roleType: payload.data.roleType,
                expiresAt: payload.data.expiresAt,
                resetPassword: payload.data.passwordReset,
                hospitalId: payload.data.hospitalId,
            }

            return { authData: newAuthData };
        },
        AUTO_SIGNIN: (currentState, payload) => {
            localStorage.setItem(LOCAL_AUTH_JWT, payload.data.token);
            localStorage.setItem(LOCAL_EXPIRES_AT, payload.data.expiresAt);
            localStorage.setItem(LOCAL_EMAIL_ID, payload.data.email);
            localStorage.setItem(LOCAL_NAME, payload.data.name);

            let newAuthData = {
                ...currentState.authData,
                email: payload.data.email,
                name: payload.data.name,
                roleType: payload.data.roleType,
                expiresAt: payload.data.expiresAt,
                resetPassword: payload.data.passwordReset,
                hospitalId: payload.data.hospitalId,
            }
            return { authData: newAuthData };
        },
        LOGOUT: (currentState, payload) => {
            localStorage.removeItem(LOCAL_AUTH_JWT);
            localStorage.removeItem(LOCAL_EMAIL_ID);
            localStorage.removeItem(LOCAL_NAME);
            localStorage.removeItem(LOCAL_EXPIRES_AT);
            let newAuthData = {
                ...currentState.authData,
                redirectPath: payload.pathName ? payload.pathName : "/",
                email: null,
                name: null,
                roleType: null,
                expiresAt: null,
                resetPassword: false,
                hospitalId: null,
            };
            return { authData: newAuthData };
        },
        HD_LOGIN: (currentState, payload) => {
            localStorage.setItem(LOCAL_AUTH_JWT, payload.data.token);
            localStorage.setItem(LOCAL_EXPIRES_AT, payload.data.expiresAt);
            localStorage.setItem(LOCAL_EMAIL_ID, payload.data.email);
            localStorage.setItem(LOCAL_NAME, payload.data.username);

            let newAuthData = {
                ...currentState.authData,
                email: payload.data.email,
                name: payload.data.username,
                username: payload.data.username,
                accountId: payload.data.accountId,
                role: payload.data.role,
                expiresAt: payload.data.expiresAt,
            };

            return { authData: newAuthData };
        },
        FORGOT_PASSWORD: (currentState, payload) => {
            let newAuthData = {
                ...currentState.authData,
                email: payload.email,
            };

            return { authData: newAuthData };
        }
    }

    // const authData = {
    //     redirectPath: null,
    //     email: null,
    //     roleType: null,
    //     expiresAt: null,
                // resetPassword: false,
                // hospitalId: null,
    // };

    initState(actions, { authData: null });
}

export default configureAuthStore;